module.exports = __webpack_public_path__ + "img/vip_hj_bg.ff143790.png";